import React, { useState } from "react";
import { Table, Button } from "react-bootstrap";
import "./SelectableBodyTable.css";

const SelectableBodyTable = ({ 
    data, 
    onToggleSelect, 
    onToggleSelectAll, 
    onEditParameter,
    onRemoveParameter,
    standardParameters = [] 
}) => {
    const [editingId, setEditingId] = useState(null);
    const [newName, setNewName] = useState("");

    const startEdit = (row) => {
        setEditingId(row.id);
        setNewName(row.parameter);
    };

    const saveEdit = () => {
        if (!newName.trim()) return;
        onEditParameter(editingId, newName.trim());
        setEditingId(null);
        setNewName("");
    };

    const cancelEdit = () => {
        setEditingId(null);
        setNewName("");
    };

    const allSelected = data.every(item => item.selected);

    const isCustomParameter = (parameter) => {
        return !standardParameters.includes(parameter);
    };

    return (
        <div className="scrollable-table-wrapper">
            <Table striped bordered hover size="sm" className="mb-0">
                <thead className="table-header">
                    <tr>
                        <th style={{ width: "8%", textAlign: "center" }}>
                            <input
                                type="checkbox"
                                checked={allSelected}
                                onChange={onToggleSelectAll}
                                style={{ margin: 0 }}
                            />
                        </th>
                        <th style={{ width: "30%" }}>Parameter</th>
                        <th style={{ width: "30%" }}>Value</th>
                        <th style={{ width: "32%" }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row) => {
                        const isEditing = editingId === row.id;
                        const isCustom = isCustomParameter(row.value);
                        
                        return (
                            <tr key={row.id}>
                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                    <input
                                        type="checkbox"
                                        checked={row.selected}
                                        onChange={() => onToggleSelect(row.id)}
                                        style={{ margin: 0 }}
                                    />
                                </td>
                                <td>
                                    {isEditing ? (
                                        <input
                                            className="form-control"
                                            value={newName}
                                            onChange={(e) => setNewName(e.target.value)}
                                        />
                                    ) : (
                                        <span>
                                            {row.parameter}
                                        </span>
                                    )}
                                </td>
                                <td>{row.value}</td>
                                <td>
                                    {isEditing ? (
                                        <>
                                            <Button
                                                variant="success"
                                                size="sm"
                                                className="me-2"
                                                onClick={saveEdit}
                                            >
                                                Save
                                            </Button>
                                            <Button
                                                variant="secondary"
                                                size="sm"
                                                onClick={cancelEdit}
                                            >
                                                Cancel
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            <Button
                                                variant="warning"
                                                size="sm"
                                                className="me-2"
                                                onClick={() => startEdit(row)}
                                            >
                                                <i className="fa fa-edit"></i>
                                            </Button>
                                            {isCustom && (
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    onClick={() => onRemoveParameter(row.id)}
                                                    title="Remove custom parameter"
                                                >
                                                    <i className="fa fa-trash"></i>
                                                </Button>
                                            )}
                                        </>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </div>
    );
};

export default SelectableBodyTable;